import {
  // appPARAMETER types
  FETCH_PROJECTNAMERESIS_DWK,
  FETCH_PROJECTNAMECOMS_DWK,
  FETCH_LOCALITYS_DWK,
} from "../actions/types";

const INITIAL_STATE = {
  projectNameResis: [],
  projectNameComs: [],
  localitys: [],
  offset: 0,
  limit: 10,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PROJECTNAMERESIS_DWK:
      return { ...state, ...action.payload };
    case FETCH_PROJECTNAMECOMS_DWK:
      return { ...state, ...action.payload };
    case FETCH_LOCALITYS_DWK:
      return { ...state, ...action.payload };

     
    default:
      return state;
  }
};
